var _rect, _path, _g, _path2, _g2, _path3, _g3, _path4, _g4, _path5, _g5, _path6, _g6, _path7, _g7, _path8, _path9;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTotalSaleIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.936279,
    y: 0.5,
    width: 33.0638,
    height: 33.0638,
    rx: 7.34752,
    fill: "#7459AF"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_13294_29298",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 10,
    y: 23,
    width: 4,
    height: 7
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.4631 23.7988H13.9476V29.0319H10.4631V23.7988Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_13294_29298)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.6246 29.0322H10.7657C10.6252 29.0322 10.4846 28.9374 10.4846 28.7483V24.1091C10.4846 23.9673 10.6252 23.8252 10.7657 23.8252H13.6246C13.7652 23.8252 13.9058 23.9673 13.9058 24.1091V28.7483C13.9058 28.9374 13.7652 29.0322 13.6246 29.0322ZM11.0471 28.4641H13.3435V24.3933H11.0471V28.4641Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_13294_29298",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 15,
    y: 21,
    width: 4,
    height: 9
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.0862 21.8613H18.5706V29.0315H15.0862V21.8613Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_13294_29298)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.265 29.0321H15.4064C15.2658 29.0321 15.125 28.9373 15.125 28.7482V22.2155C15.125 22.0737 15.2658 21.9316 15.4064 21.9316H18.265C18.4525 21.9316 18.5461 22.0737 18.5461 22.2155V28.7482C18.5461 28.9373 18.4525 29.0321 18.265 29.0321ZM15.6875 28.464H17.9839V22.4997H15.6875V28.464Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_13294_29298",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 19,
    y: 19,
    width: 5,
    height: 11
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.7085 19.1348H23.2641V29.0313H19.7085V19.1348Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_13294_29298)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.9508 29.0314H20.0453C19.9047 29.0314 19.7642 28.9367 19.7642 28.7475V19.4695C19.7642 19.3276 19.9047 19.1855 20.0453 19.1855H22.9508C23.0914 19.1855 23.232 19.3276 23.232 19.4695V28.7475C23.232 28.9367 23.0914 29.0314 22.9508 29.0314ZM20.3264 28.4633H22.6697V19.7536H20.3264V28.4633Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_13294_29298",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 22,
    y: 10,
    width: 8,
    height: 20
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M22.8374 10.2393H29.4686V29.0324H22.8374V10.2393Z",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_13294_29298)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.591 29.0311H24.7324C24.5919 29.0311 24.4513 28.9364 24.4513 28.7472V15.3984H23.1391C23.0452 15.3984 22.9516 15.351 22.9046 15.2563C22.858 15.1616 22.858 15.0671 22.9046 14.9724L25.8571 10.4282C25.9041 10.3335 25.9977 10.2861 26.0916 10.2861C26.1852 10.2861 26.2322 10.3335 26.3258 10.4282L29.3719 14.925C29.4188 14.9724 29.4658 15.0671 29.4658 15.1145C29.4658 15.2563 29.3252 15.3984 29.1847 15.3984H27.8724V28.7472C27.8724 28.9364 27.7316 29.0311 27.591 29.0311ZM25.0135 28.463H27.3099V15.1145C27.3099 14.9724 27.4505 14.8303 27.591 14.8303H28.6222L26.0916 11.0908L23.6546 14.8303H24.7324C24.873 14.8303 25.0135 14.9724 25.0135 15.1145V28.463Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask4_13294_29298",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 8,
    y: 28,
    width: 21,
    height: 2
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M8.75732 28.4619H28.953V29.0314H8.75732V28.4619Z",
    fill: "white"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4_13294_29298)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.6688 29.031H9.07945C8.9389 29.031 8.79834 28.9363 8.79834 28.7471C8.79834 28.605 8.9389 28.4629 9.07945 28.4629H28.6688C28.8563 28.4629 28.9499 28.605 28.9499 28.7471C28.9499 28.9363 28.8563 29.031 28.6688 29.031Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask5_13294_29298",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 7,
    y: 5,
    width: 18,
    height: 18
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M7.61914 5.03223H24.4726V22.6506H7.61914V5.03223Z",
    fill: "white"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask5_13294_29298)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.84564 22.64C8.23647 22.64 7.72091 22.2138 7.6273 21.6459C7.58036 21.1252 7.86147 20.5098 8.61148 20.2732C9.12703 20.1311 9.68926 19.8943 10.0643 19.7051C10.2048 19.6578 10.3454 19.6104 10.4859 19.5157C11.5171 19.0423 12.5479 18.3798 13.4854 17.717C16.391 15.587 18.4999 12.8886 19.7652 9.71719C19.9527 9.1491 20.1868 8.53393 20.3274 7.96584L20.3743 7.82375L18.8279 7.16093C18.734 7.11384 18.6404 7.01912 18.6404 6.87702C18.6404 6.7823 18.734 6.68757 18.8279 6.64048L22.5302 5.07831C22.6707 5.03094 22.8582 5.07831 22.9049 5.2204L24.4516 9.00729C24.4985 9.10174 24.4516 9.24383 24.4046 9.29119C24.311 9.38592 24.1705 9.43329 24.0766 9.38592L22.5768 8.7231C21.9207 10.9478 20.9368 12.9834 19.6713 14.8294C18.359 16.6281 16.719 18.2851 14.8443 19.6578C13.626 20.5571 12.3137 21.3144 11.0015 21.8825C10.5329 22.1193 9.92371 22.4032 9.31426 22.5453C9.12703 22.5927 8.9862 22.64 8.84564 22.64ZM19.6713 6.87702L20.8429 7.39775C20.9368 7.44511 21.0304 7.58721 20.9835 7.72902L20.8899 8.10765C20.7024 8.7231 20.5149 9.33856 20.2807 9.95401C18.9685 13.2202 16.8126 15.9656 13.8601 18.143C12.8293 18.9005 11.7982 19.5157 10.7204 20.0364C10.5798 20.0838 10.439 20.1785 10.2984 20.2259C9.87676 20.415 9.31426 20.6992 8.79898 20.841C8.28342 20.9831 8.14286 21.3144 8.18953 21.5512C8.23647 21.8351 8.42397 22.0719 8.84564 22.0719C8.93953 22.0719 9.03315 22.0719 9.12703 22.0246C9.68926 21.8351 10.2984 21.5986 10.767 21.3618C12.0793 20.794 13.2979 20.0364 14.5162 19.1844C18.2185 16.4863 20.8429 12.7942 22.0616 8.4392L22.1082 8.24974C22.1082 8.20238 22.2021 8.10765 22.2488 8.10765C22.3427 8.06057 22.3896 8.06057 22.4832 8.10765L23.6549 8.58101L22.4832 5.69376L19.6713 6.87702Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask6_13294_29298",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 5,
    y: 5,
    width: 11,
    height: 11
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M5.46802 5.5752H15.797V15.9785H5.46802V5.5752Z",
    fill: "white"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask6_13294_29298)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.626 15.9662C7.8143 15.9662 5.47095 13.6467 5.47095 10.8066C5.47095 7.91905 7.8143 5.59961 10.626 5.59961C13.4849 5.59961 15.781 7.91905 15.781 10.8066C15.781 13.6467 13.4849 15.9662 10.626 15.9662ZM10.626 6.1677C8.09541 6.1677 6.03345 8.25032 6.03345 10.8066C6.03345 13.3626 8.09541 15.3981 10.626 15.3981C13.1568 15.3981 15.2188 13.3626 15.2188 10.8066C15.2188 8.25032 13.1568 6.1677 10.626 6.1677Z",
    fill: "white"
  }))), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.6259 13.8851C9.7356 13.8851 8.9856 13.1279 8.9856 12.1812C8.9856 12.0391 9.07949 11.897 9.26699 11.897C9.40754 11.897 9.5481 12.0391 9.5481 12.1812C9.5481 12.7966 10.0167 13.317 10.6259 13.317C11.2353 13.317 11.7506 12.7966 11.7506 12.1812C11.7506 11.5657 11.2353 11.0923 10.6259 11.0923C9.7356 11.0923 8.9856 10.3351 8.9856 9.38835C8.9856 8.48899 9.7356 7.73145 10.6259 7.73145C11.5634 7.73145 12.3131 8.48899 12.3131 9.38835C12.3131 9.53016 12.1726 9.67225 12.032 9.67225C11.8445 9.67225 11.7506 9.53016 11.7506 9.38835C11.7506 8.7729 11.2353 8.29953 10.6259 8.29953C10.0167 8.29953 9.5481 8.7729 9.5481 9.38835C9.5481 10.0035 10.0167 10.5242 10.6259 10.5242C11.5634 10.5242 12.3131 11.2818 12.3131 12.1812C12.3131 13.1279 11.5634 13.8851 10.6259 13.8851Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.6254 14.3114C10.4848 14.3114 10.3442 14.1695 10.3442 14.0274V7.58985C10.3442 7.40039 10.4848 7.30566 10.6254 7.30566C10.7659 7.30566 10.9067 7.40039 10.9067 7.58985V14.0274C10.9067 14.1695 10.7659 14.3114 10.6254 14.3114Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTotalSaleIcon);
export default __webpack_public_path__ + "static/media/total-sale-icon.44c79ac7ebb4239f84e84a396b4d9c57.svg";
export { ForwardRef as ReactComponent };